<template>
  <div>
    <px-view-header title="Indicadores de frete"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-else>
      <v-row v-if="indicadores">
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="indicadores.FINALIZADA"
                               class="rounded-card"
                               color="success"
                               description="cotações fechadas"
                               icon="mdi-currency-usd"/>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="pendentesCotacoes"
                               color="warning"
                               class="rounded-card"
                               description="cotações abertas"
                               icon="mdi-cart"/>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="indicadores.CANCELADA"
                               color="error"
                               class="rounded-card"
                               description="cotações canceladas"
                               icon="mdi-cancel"/>
          </v-hover>
        </v-col>
      </v-row>
      <v-row v-if="indicadoresContratos">
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="indicadoresContratos.APROVADO"
                               color="success"
                               class="rounded-card"
                               description="contratos realizados"
                               icon="mdi-currency-usd"/>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="indicadoresContratos.PENDENTE_TRANSPORTADOR"
                               color="warning"
                               class="rounded-card"
                               description="contratos em andamento"
                               icon="mdi-cart"/>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="4">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-indicador-card :elevation="hover ? 12 : 2"
                               :value="indicadoresContratos.CANCELADO"
                               color="error"
                               class="rounded-card"
                               description="contratos cancelados"
                               icon="mdi-cancel"/>
          </v-hover>
        </v-col>
      </v-row>
      <v-row class="text-center align-center justify-center">
        <v-col cols="12" sm="12" md="12" lg="6">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-dashboard-frete-savings :elevation="hover ? 12 : 2"/>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <v-hover v-slot:default="{ hover }" open-delay="100">
            <px-dashboard-frete-contratos :elevation="hover ? 12 : 2"/>
          </v-hover>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import IndicadoresFreteService from './dashboard-frete-service';
import DashboardFreteSavings from './DashboardFreteSavings.vue';
import DashboardFreteContratos from './DashboardFreteContratos.vue';

export default {
  data() {
    return {
      loading: false,
      indicadores: null,
      indicadoresContratos: null,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Indicadores de frete' },
      ],
    };
  },
  computed: {
    pendentesCotacoes() {
      if (!this.indicadores) {
        return 0;
      }
      return (this.indicadores.ABERTA || 0)
        + (this.indicadores.COMPRA || 0);
    },
  },
  methods: {
    getIndicadores() {
      this.loading = true;
      IndicadoresFreteService.getIndicadores()
        .then((response) => {
          this.indicadores = response.data;
          return this.getIndicadoresContratos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getIndicadoresContratos() {
      IndicadoresFreteService.getIndicadoresContratos()
        .then((response) => {
          this.indicadoresContratos = response.data;
        });
    },
  },
  created() {
    this.getIndicadores();
  },
  components: {
    pxDashboardFreteSavings: DashboardFreteSavings,
    pxDashboardFreteContratos: DashboardFreteContratos,
  },
};
</script>
